export const accountTypes = {
  privateAccount: "private",
  businessAccount: "business",
  b2b: "b2b"
};
